import { Check } from "lucide-react";

const ABOUT_IMG = "https://images.unsplash.com/photo-1667133295315-820bb6481730?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxkZW50aXN0JTIwdHJlYXRpbmclMjBwYXRpZW50JTIwc21pbGluZ3xlbnwwfHx8fDE3ODgxNDU0MDZ8MA&ixlib=rb-4.1.0&q=85";

const points = [
    "Personalized dental consultation",
    "Preventive dental care",
    "Restorative dental solutions",
    "Comfortable patient experience",
    "Clear treatment guidance",
];

export const About = () => (
    <section id="about" className="bg-white py-20 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="relative order-2 lg:order-1" data-testid="about-image-wrapper">
                <div className="absolute -inset-4 rounded-[2rem] bg-sky-50 -rotate-2" aria-hidden="true" />
                <img
                    src={ABOUT_IMG}
                    alt="Dentist providing gentle care to a patient"
                    className="relative rounded-3xl object-cover w-full h-[320px] sm:h-[420px] lg:h-[480px] shadow-[0_20px_50px_rgba(2,44,40,0.14)]"
                    loading="lazy"
                />
            </div>

            <div className="order-1 lg:order-2" data-testid="about-content">
                <p className="text-xs font-bold uppercase tracking-[0.22em] text-teal-600 mb-4">About Our Clinic</p>
                <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
                    Personalized Dental Care for Every Smile
                </h2>
                <p className="mt-5 text-base leading-relaxed text-slate-600">
                    At The Tooth Care Dental Clinic, we believe good dentistry starts with listening. Every visit begins
                    with a careful consultation, where we take the time to understand your concerns, examine your oral
                    health and explain your options in simple, honest terms.
                </p>
                <p className="mt-4 text-base leading-relaxed text-slate-600">
                    From preventive check-ups that keep problems away, to restorative treatments that bring damaged
                    teeth back to health, our focus is always the same: comfortable care, clear guidance and results
                    that protect your smile for the long run.
                </p>
                <ul className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-3.5" data-testid="about-key-points">
                    {points.map((p) => (
                        <li key={p} className="flex items-center gap-2.5">
                            <span className="h-6 w-6 rounded-full bg-teal-50 flex items-center justify-center shrink-0">
                                <Check className="h-3.5 w-3.5 text-teal-600" strokeWidth={2.5} />
                            </span>
                            <span className="text-sm font-medium text-slate-700">{p}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    </section>
);
